Vue.component 'product-item',
    template: """
<div v-show="shown">
    <div>
        <a :href="prod.url">
            <img :src="prod.img" :alt="prod.name"/>
        </a>
    </div>
    <h3>{{prod.name}}</h3>
    <p>{{prod.excerpt}}</p>
</div>
"""
    props: ['prod', 'filters']

    data: ->
        stub: null

    computed:
        shown: ->
            for f in fields
                allClear = do =>
                    return false for k, v of @filters[f] when v
                    true
                if not @filters[f][@prod[f]] and not allClear
                    return @prod.visible = false
            @prod.visible = true

Vue.component 'product-filter',
    template: """
<div v-show='shown'>
    <h3>{{title}}</h3>
    <ul style="display: block">
        <li v-for='v,k in filter' v-show='switchShown(k)'>
            <label>
                <input type='checkbox' v-model="filter[k]" />
                {{k}}
            </label>
        </li>
    </ul>
</div>
"""
    props: ['title', 'products', 'filter']

    computed:
        shown: -> Object.keys(@filter).length > 1

    methods:
        switchShown: (k)->
            return true for p in @$parent.shownProducts when p[@title] is k
            false


@makeApp = (filters, products)-> new Vue
    el: "#shop-body"
    data:
        filters: filters
        products: products

    computed:
        shownProducts: -> @products.filter (p)-> p.visible